module.exports = __webpack_public_path__ + "img/case18.09fee417.jpg";